export const risks = [
  {
    ProjectUID: "6671c86b-cc7a-4601-accf-06ce4343646a",
    ProjectName: "تنفيذ الاعمال الهندسية المطلوبة للفروع",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "إدارية",
    RiskTitle: "اعتماد المخرجات",
    Exposure: 3,
  },
  {
    ProjectUID: "6671c86b-cc7a-4601-accf-06ce4343646a",
    ProjectName: "مشروع تأسيس و تشغيل منصة ذكاء الأعمال",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "زمني",
    RiskTitle: "عوامل خارجية",
    Exposure: 4,
  },
  {
    ProjectUID: "6671c86b-cc7a-4601-accf-06ce4343646a",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "موارد (بشرية، لوجستية)",
    RiskTitle: "عوامل خارجية",
    Exposure: 5,
  },
  {
    ProjectUID: "07e4f787-8974-eb11-8af0-005056921d78",
    ProjectName: " مشروع تأسيس و تشغيل منصة ذكاء الأعمال ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "قانونية",
    RiskTitle: "التأخر في صرف الدفعة الاخيرة",
    Exposure: 5,
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: " مشروع تأسيس و تشغيل منصة ذكاء الأعمال ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "موارد (بشرية، لوجستية)",
    RiskTitle: "عوامل خارجية",
    Exposure: 5,
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "قانونية",
    RiskTitle: "عوامل خارجية",
    Exposure: 2,
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "زمني",
    RiskTitle: "عوامل خارجية",
    Exposure: 5,
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "إدارية",
    RiskTitle: "المعنيين بالمشروع",
    Exposure: 5,
  },
  {
    ProjectUID: "42c55b53-076c-4aa0-8a4c-bb4b01002aa5",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الاعمال",
    RiskType: "زمني",
    RiskTitle: "الخطة الزمنية",
    Exposure: 4,
  },
  {
    ProjectUID: "68e05623-2a75-eb11-8af1-005056921d78",
    ProjectName: " تنفيذ الاعمال الهندسية المطلوبة للفروع ",
    "أولوية المشروع": "Special Tier (1)",
    القطاع: "قطاع الخدمات المشتركة",
    RiskType: "فنية",
    RiskTitle: "عدم التزام المقاول بكافة المتطلبات",
    Exposure: 3,
  },
];
